import React from 'react';

import { Row, Col } from 'antd';

import styled from 'styled-components';

import { ContactDetailsContainer } from '@components/ContactDetails/CommonStyles/ContactDetailsContainer';

import { useUserPermission } from '@contexts/UserContext';

import { useContactConnections } from '@hooks/API/Contact/UseContactConnections';

import ContactDetailsTasks from '../CommonComponents/ContactDetailsTasks';
import ContactDetailsStatement from '@components/ContactDetails/CommonComponents/ContactDetailsStatement';
import CustomerDetailsConnections from '@components/ContactDetails/CustomerDetails/CommonComponents/CustomerDetailsConnections';
import CustomerDetailsCustomPropertiesAndNotesTabs from '@components/ContactDetails/CustomerDetails/CommonComponents/CustomerDetailsCustomPropertiesAndNotesTabs';

import AgencyModelsCard from '@components/AgencyModels/AgencyModelsCard';
import CustomerDetailsHeaderDrawerAccounting from '@components/ContactDetails/ContactDetailsHeader/CustomerDetailsHeaderDrawerAccounting';
import ContactDetailsDocuments from '@components/ContactDetailsDocuments/ContactDetailsDocuments';
import { Loading } from '@components/Gui/Loading';
import SystemMessage from '@components/Utils/SystemMessage';

const CardLine = styled.div`
    margin-bottom: 12px;
    box-sizing: border-box;
`;

const CustomerDetailsAccountingContent = ({ currentCustomer, billingInfos, isFullPage, onReloadSearch }) => {
    const accessAccounting = useUserPermission('AccessAccounting');

    const { data: currentCustomerConnections, isFetching: isFetchingConnections } = useContactConnections(
        currentCustomer.ID
    );

    if (!accessAccounting) {
        return <SystemMessage type="not-allowed" />;
    }

    return (
        <ContactDetailsContainer className="model-drawer-accounting">
            <CustomerDetailsHeaderDrawerAccounting
                currentContact={currentCustomer}
                billingInfos={billingInfos}
                drawerMode
                onOpenModelAgencies={() => {}}
                onOpenStatements={() => {}}
                onReloadSearch={onReloadSearch}
            />
            {currentCustomer && currentCustomer.Approved && billingInfos && billingInfos.length > 0 && (
                <ContactDetailsStatement
                    contactID={currentCustomer.ID}
                    contactType={currentCustomer.ContactType}
                    contactSubType={currentCustomer.SubType}
                />
            )}
            {/* {isFullPage ? (
                <Row gutter={10}>
                    <Col span={14}>
                        <ModelAgenciesCard
                            contactID={currentModel.ID}
                            represented={currentModel.Represented}
                            drawerMode
                        />
                    </Col>
                    <Col span={10}>
                        <ContactDetailsDocuments currentContact={currentModel} readOnly />
                    </Col>
                </Row>
            ) : (
                <CardLine>
                    <ModelAgenciesCard contactID={currentModel.ID} represented={currentModel.Represented} drawerMode />
                </CardLine>
            )} */}

            <CardLine>
                {currentCustomer.SubType === 2 ? (
                    <>
                        <Row gutter={10} type="flex">
                            <Col span={14}>
                                <AgencyModelsCard contactID={currentCustomer.ID} />
                            </Col>
                            <Col span={10}>
                                {isFetchingConnections ? (
                                    <Loading />
                                ) : (
                                    <CustomerDetailsConnections
                                        currentContact={currentCustomer}
                                        currentContactConnections={currentCustomerConnections}
                                        contactID={currentCustomer.ID}
                                    />
                                )}
                            </Col>
                        </Row>
                    </>
                ) : (
                    <Row gutter={10} type="flex">
                        <Col span={24}>
                            <CustomerDetailsConnections
                                currentContact={currentCustomer}
                                currentContactConnections={currentCustomerConnections}
                                contactID={currentCustomer.ID}
                                fullWidth
                            />
                        </Col>
                    </Row>
                )}
            </CardLine>
            {/* {isFullPage ? ( */}
            <CardLine>
                <Row gutter={10} style={{ marginTop: '12px' }}>
                    <Col span={14}>
                        <CustomerDetailsCustomPropertiesAndNotesTabs currentContact={currentCustomer} drawerMode />
                    </Col>
                    <Col span={10}>
                        <ContactDetailsTasks currentContact={currentCustomer} />
                    </Col>
                </Row>
            </CardLine>
            {/* ) : (
                <>
                    <CardLine>
                        <ContactDetailsTasks currentContact={currentCustomer} />
                    </CardLine>
                    <CardLine>
                        <CustomerDetailsCustomPropertiesAndNotesTabs currentContact={currentCustomer} drawerMode />
                    </CardLine>
                </>
            )} */}
            {!isFullPage && (
                <CardLine>
                    <ContactDetailsDocuments currentContact={currentCustomer} readOnly />
                </CardLine>
            )}
        </ContactDetailsContainer>
    );
};

export default CustomerDetailsAccountingContent;
